export interface Category {
  id: string;
  name: string;
  icon: string;
  desc: string;
}

export interface NewsItem {
  slug: string;
  categoryId: string;
  title: string;
  summary: string;
  tag: string;
  author: string;
  date: string;
  time: string;
  views: number;
  heat: number;
  readMin: number;
  featured?: boolean;
  top?: boolean;
  image: string;
  paragraphs: string[];
}

export const categories: Category[] = [
  { id: "entertainment", name: "明星动态", icon: "ri-star-smile-line", desc: "艺人大事与营业日常" },
  { id: "film", name: "影视综艺", icon: "ri-clapperboard-line", desc: "新片热剧与口碑综艺" },
  { id: "society", name: "社会热点", icon: "ri-focus-3-line", desc: "全网热议的社会话题" },
  { id: "tech", name: "科技数码", icon: "ri-smartphone-line", desc: "新品发布与前沿资讯" },
  { id: "life", name: "生活潮流", icon: "ri-cup-line", desc: "生活美学与新鲜事" },
];

export const hotNews: NewsItem[] = [
  {
    slug: "summer-boxoffice-black-horse",
    categoryId: "film",
    title: "暑期档票房黑马杀出重围，冷门题材如何逆袭成爆款",
    summary: "在铺天盖地的大片夹击下，一部不被看好的冷门题材作品却成了影院里的最大惊喜。它凭什么跑赢档期？",
    tag: "院线",
    author: "瓜瓜观察员",
    date: "09-08",
    time: "08:12",
    views: 1286000,
    heat: 982,
    featured: true,
    top: true,
    readMin: 5,
    image: "https://readdy.ai/api/search-image?query=cinematic%20cinema%20audience%20silhouettes%20watching%20warm%20golden%20projector%20light%20in%20a%20dark%20movie%20theater%2C%20editorial%20photography%2C%20atmospheric%20glow%2C%20soft%20film%20grain%2C%20cinematic%20mood&width=960&height=620&seq=hot-news-film-01&orientation=landscape",
    paragraphs: [
      "今年暑期档开局并不算热烈，几部被寄予厚望的商业大片口碑两极，反而给了一部几乎零宣传的冷门作品可乘之机。上映首周，它凭借扎实的口碑在社交平台掀起自发讨论，上座率一路走高，最终成为档期内当之无愧的黑马。",
      "业内人士复盘时发现，这部影片走红的路径非常清晰：不靠堆砌明星，而是用细腻的故事和真诚的表达打动观众。第一批自来水在短视频平台发布观影感受后，裂变式的传播让越来越多路人走进影院。",
      "影院经理老陈告诉我们，排片量从首日的 3% 一路加码到次周的 28%，这在院线排片的历史上都算罕见。散场后观众讨论的热情，正是好内容最有说服力的注脚。",
      "也有观点提醒，黑马的成功不能简单复制。市场仍需要差异化题材，但更需要尊重创作规律、敬畏观众审美。当越来越多这样的作品冒头，整个行业的想象力也会被重新打开。",
      "无论如何，这个夏天的爆款故事都在告诉我们：好故事永远不会被埋没，观众的眼睛是雪亮的。",
    ],
  },
  {
    slug: "summit-concert-stage-tech",
    categoryId: "entertainment",
    title: "一场演唱会带火万人合唱，舞台科技与真唱的边界在哪",
    summary: "大屏、光影与动辄上万的现场观众让演唱会成为热门话题，真唱还是修音也在评论区吵翻了天。",
    tag: "舞台",
    author: "晚风",
    date: "09-08",
    time: "06:40",
    views: 903000,
    heat: 876,
    top: true,
    readMin: 4,
    image: "https://readdy.ai/api/search-image?query=large%20pop%20concert%20stage%20with%20warm%20orange%20spotlights%20and%20massive%20crowd%20of%20fans%20holding%20phones%20up%2C%20night%20outdoor%20stadium%2C%20energetic%20atmosphere%2C%20editorial%20photography&width=960&height=620&seq=hot-news-concert-01&orientation=landscape",
    paragraphs: [
      "昨晚的一场万人演唱会登上了实时热度榜，现场观众的合唱视频在网络上被反复转发。有人说这才是演唱会该有的样子，也有人把镜头拉近，逐帧讨论歌手的声音细节，试图找出演唱技术处理的痕迹。",
      "近年来舞台视觉技术飞速进步，全息投影、升降机械、巨型 LED 屏让演出变成一场视觉盛宴。但技术越先进，观众对现场真实感的期待也越高——高音是不是真的、有没有对口型，成了每次演出的最高关注点。",
      "现场乐迷小林表示，比起完美无瑕的录音室音质，她更在意情绪的传递。真正让人动容的是全场一起唱歌的那个瞬间，那是一种无法被任何技术替代的连接感。",
      "音乐制作人则认为，现代演出里适度的人声处理和修音辅助并不罕见，关键看是否坦诚。观众反感的从来不是技术，而是欺骗与傲慢。",
      "舞台之上，技术的边界可以被不断突破，但真诚永远是最高的舞台规格。",
    ],
  },
  {
    slug: "holiday-hot-spring-travel",
    categoryId: "life",
    title: "假期短途游热度飙升，年轻人为泡汤和露营连夜抢票",
    summary: "不想长途跋涉的年轻人们，把目光投向了城市周边，温泉、露营、民宿成了周末游的新宠。",
    tag: "出行",
    author: "米粒",
    date: "09-08",
    time: "05:20",
    views: 465000,
    heat: 634,
    readMin: 3,
    image: "https://readdy.ai/api/search-image?query=cozy%20glamping%20camping%20site%20at%20sunset%20with%20warm%20tent%20lights%20and%20campfire%2C%20young%20people%20relaxing%2C%20soft%20golden%20hour%2C%20lifestyle%20editorial%20photography&width=960&height=620&seq=hot-news-travel-01&orientation=landscape",
    paragraphs: [
      "今年假期旅游市场出现了一个明显变化：长途打卡的热度有所降温，城市周边的短途游反而火了起来。距离市区一两小时车程的温泉度假村和露营基地，成了年轻上班族放松的首选。",
      "小宇和同事提前一周就订好了郊区的帐篷营地，在他看来，不需要抢昂贵的机票，也不用在人山人海里排队，和朋友生一堆篝火、看一场露天电影，就已经是很治愈的假期了。",
      "多家平台的预订数据显示，假期前一周，温泉类与露营类产品搜索量环比大幅上涨，部分热门民宿的预订甚至要连抢几次才能成功。价格亲民、体验丰富、随走随停，是它们受欢迎的重要原因。",
      "业内人士分析，这种趋势背后是年轻人旅行观念的转变——从打卡证明自己来过，到真正放松和享受当下。距离不再重要，舒服最重要。",
      "短途游的爆火，或许正是忙碌都市生活里，人们为自己找到的一处柔软出口。",
    ],
  },
  {
    slug: "smart-home-ai-voice",
    categoryId: "tech",
    title: "AI 助手走进千万家庭，智能家电正学会主动思考",
    summary: "从一句话开灯到自动调节全屋环境，语音助手与多设备联动正把家电体验带入新阶段。",
    tag: "智能",
    author: "程序瓜",
    date: "09-08",
    time: "04:05",
    views: 388000,
    heat: 521,
    readMin: 4,
    image: "https://readdy.ai/api/search-image?query=modern%20bright%20smart%20home%20living%20room%20with%20smart%20speaker%20and%20connected%20devices%2C%20warm%20natural%20light%2C%20clean%20minimal%20interior%2C%20editorial%20product%20photography&width=960&height=620&seq=hot-news-tech-01&orientation=landscape",
    paragraphs: [
      "当人工智能不再只是聊天框里的文字，而是住进客厅的音响、厨房的烤箱和卧室的灯光系统，智能家居正迎来一场体验升级。过去需要手动设置的一串串指令，如今一句话就能完成。",
      "上班族阿哲分享了他的日常：回家前说一声，玄关灯自动亮起、空调提前调到舒适温度、咖啡机开始预热。这些细微的联动看似简单，背后却是设备之间不断学习他生活习惯的结果。",
      "厂商们也在强调，真正的智能不该是给每个家电加一个屏幕，而是让它们彼此协作、理解场景。窗帘知道什么时候该拉上，空气净化器懂得在雾霾天提前开启，这都比单纯用手机遥控来得更有意义。",
      "当然，隐私与数据安全问题仍是绕不开的课题。如何在不滥用用户数据的前提下提供贴心服务，考验着每一家企业的耐心与底线。",
      "可以预见，随着更多设备加入生态，家的概念正在被重新定义——它开始有听觉，有感知，甚至越来越懂得我们。",
    ],
  },
  {
    slug: "city-night-market-economy",
    categoryId: "society",
    title: "夜市烟火气重回街头，人间味与城市秩序如何兼得",
    summary: "规范化的夜市街区接连亮相，摊主回归、客流回升，夜经济的烟火气正在被认真对待。",
    tag: "城市",
    author: "阿楠",
    date: "09-07",
    time: "21:30",
    views: 742000,
    heat: 789,
    readMin: 4,
    image: "https://readdy.ai/api/search-image?query=vibrant%20street%20night%20market%20food%20stalls%20with%20warm%20string%20lights%20and%20steam%20rising%2C%20people%20walking%20enjoying%20street%20food%2C%20cozy%20evening%20atmosphere%2C%20editorial%20photography&width=960&height=620&seq=hot-news-nightmarket-01&orientation=landscape",
    paragraphs: [
      "夜晚九点，城市的一角又亮起了成串的暖黄色小灯。烤串的香气、热腾腾的炒粉、此起彼伏的叫卖声，让冷清了许久的街角重新热闹起来。规范的夜市街区，正在成为许多城市夜晚的新地标。",
      "做过多年夜宵摊的老周很感慨，以前摆摊总是东躲西藏，现在有了固定摊位和统一管理，生意稳定了，心里也踏实了。对他而言，这不只是一份收入，更是一种被城市接纳的归属感。",
      "夜经济的价值远不止一顿夜宵那么简单。它带动了就业、刺激了消费，也让一座城市在白天的高楼大厦之外，多了一层接地气的人情味。年轻人下班后结伴逛夜市，成了解压的新方式。",
      "如何在释放烟火气的同时维护好卫生、噪音与通行秩序，是摆在城市管理者面前的考题。可喜的是，越来越多地方正尝试用规划而非简单取缔的方式，去寻找人情与规则的平衡点。",
      "一座真正有温度的城，既有白天的繁忙，也容得下夜晚的喧闹。",
    ],
  },
  {
    slug: "sports-marathon-craze",
    categoryId: "society",
    title: "马拉松报名爆满一签难求，城市跑步热为何停不下来",
    summary: "从清晨跑道到周末赛事，跑步正从运动变成一种生活方式，年轻人把它当成了新的社交货币。",
    tag: "运动",
    author: "元气跑者",
    date: "09-07",
    time: "18:45",
    views: 512000,
    heat: 668,
    readMin: 3,
    image: "https://readdy.ai/api/search-image?query=diverse%20group%20of%20young%20runners%20jogging%20in%20a%20city%20park%20at%20sunrise%2C%20warm%20morning%20light%2C%20energetic%20healthy%20lifestyle%2C%20editorial%20photography&width=960&height=620&seq=hot-news-run-01&orientation=landscape",
    paragraphs: [
      "上周末的一场城市马拉松，报名通道开启不到半小时就全部报满，中签率再创新低。没有中签的跑者们一边遗憾，一边已经锁定了下一场赛事的日期。",
      "在社交平台上，跑步早已不只是晒公里数那么简单。晒配速、晒装备、晒完赛奖牌，甚至约上陌生人组成训练小队，跑步成了很多年轻人生活方式的一部分，也悄悄变成了新的社交语言。",
      "运动品牌乘势推出各式各样的联名跑鞋与训练课程，城市绿地也增加了夜跑照明与补给站。让跑步这件事变得更友好、更专业，正在成为多方的共识。",
      "专家提醒，跑马拉松要循序渐进，科学训练比盲目堆跑量更重要。热度之下，更需要一颗平常心去享受奔跑本身的快乐。",
      "清晨的城市里，越来越多奔跑的身影，正成为健康与活力最生动的注脚。",
    ],
  },
  {
    slug: "luxury-brand-resale-revival",
    categoryId: "life",
    title: "闲置转卖热度走高，年轻人的消费观悄悄变了吗",
    summary: "买二手不再等于寒酸，捡漏好货反而成了潮流。二手交易平台上的年轻人，正在重构消费的定义。",
    tag: "消费",
    author: "栗子",
    date: "09-07",
    time: "15:10",
    views: 356000,
    heat: 480,
    readMin: 4,
    image: "https://readdy.ai/api/search-image?query=stylish%20young%20person%20browsing%20a%20neatly%20arranged%20vintage%20secondhand%20boutique%20with%20warm%20cozy%20lighting%2C%20clothes%20racks%20and%20bags%2C%20lifestyle%20editorial%20photography&width=960&height=620&seq=hot-news-vintage-01&orientation=landscape",
    paragraphs: [
      "在许多人还在为要不要买新款纠结时，一批年轻人已经把目光转向了二手市场。他们在这里淘绝版、捡好价，也把自己不再需要的物品转手出去，让闲置重新流动起来。",
      "刚毕业两年的小艾就是二手平台的常客。她把不想再背的包、闲置的相机转卖出去，再购入心仪已久的复古单品。在她看来，这既是对钱包的尊重，也是一种更松弛、更聪明的消费方式。",
      "平台数据显示，时尚、数码和户外用品是二手交易量增长最快的品类。随着鉴真体系与售后保障逐渐成熟，曾经劝退不少人的信任门槛正在被一点点打破。",
      "有分析认为，这背后是消费观念的一次集体升级：人们越来越在意物品的真实价值，而非简单的价格标签或品牌光环。循环利用也不再只是环保口号，而是一种切实可行的生活方式。",
      "当冲动消费退潮，理性回归，我们对物品的态度，也折射出对生活的掌控感。",
    ],
  },
  {
    slug: "variety-return-season",
    categoryId: "film",
    title: "多档综艺回归口碑两极，慢综艺为何总能击中观众",
    summary: "新一季综艺陆续开播，有人喊停不下，也有人直呼套路。回归生活的慢综艺，反而成了稳定输出。",
    tag: "综艺",
    author: "小乔",
    date: "09-07",
    time: "11:25",
    views: 689000,
    heat: 713,
    featured: true,
    readMin: 5,
    image: "https://readdy.ai/api/search-image?query=cheerful%20group%20of%20friends%20cooking%20and%20chatting%20at%20a%20rustic%20countryside%20cottage%20table%2C%20warm%20sunlight%2C%20relaxed%20slow%20variety%20show%20feel%2C%20editorial%20photography&width=960&height=620&seq=hot-news-variety-01&orientation=landscape",
    paragraphs: [
      "随着多档老牌综艺陆续回归，观众的讨论也随之热闹起来。有人感叹熟悉的配方让人上头，也有人抱怨内容越来越套路，看点全靠剪辑与嘉宾硬撑。口碑呈现明显两极分化。",
      "在一片喧嚣中，主打田园生活与朋友闲谈的慢综艺却始终保持着稳定的好评率。没有激烈的竞技，没有刻意的冲突，一群人认真做饭、认真聊天，反而让疲惫的观众找到了喘息的角落。",
      "节目制作人透露，慢综艺的难点在于不加戏却要有看点，这极其考验嘉宾之间的化学反应与剪辑节奏的把控。真正的松弛感，恰恰是装不出来的。",
      "观众的变化也很明显：越来越多人厌倦了被喂到嘴边的强情绪，转而渴望真实、真诚与治愈感。热闹一时易，走心却难得。",
      "或许慢综艺之所以总能击中人心，是因为在快节奏的世界里，它替我们守护了一份不被催促的生活想象。",
    ],
  },
  {
    slug: "telecom-folding-phone-price",
    categoryId: "tech",
    title: "折叠屏手机价格走低，新形态会成为主流吗",
    summary: "随着价格门槛一再下探，折叠屏手机开始进入更多人的购物车，也引发了一场关于未来形态的讨论。",
    tag: "数码",
    author: "Tech瓜",
    date: "09-06",
    time: "20:50",
    views: 298000,
    heat: 445,
    readMin: 4,
    image: "https://readdy.ai/api/search-image?query=futuristic%20foldable%20smartphone%20half%20open%20on%20a%20minimal%20desk%20with%20warm%20ambient%20lighting%2C%20clean%20product%20photography%2C%20modern%20tech%20aesthetic&width=960&height=620&seq=hot-news-fold-01&orientation=landscape",
    paragraphs: [
      "前几年还被视为高端尝鲜品的折叠屏手机，如今价格不断下探，部分机型已进入主流价位区间。一度犹豫观望的消费者，开始把折叠屏放进了自己的换机清单。",
      "在数码评测人看来，铰链工艺的成熟、屏幕折痕的改善以及轻薄化设计，是折叠屏得以普及的关键。当展开后的大屏体验与收起的便携不再二选一，它便有了打动普通用户的基础。",
      "不过也有用户表示顾虑，担心维修成本与耐用度。厂商们显然也注意到了这一点，纷纷在屏幕保护、转轴质保与售后政策上做文章，试图打消消费者的后顾之忧。",
      "从销量走势看，折叠屏已不再是厂商炫技的展示品，而开始真正进入家庭场景，用来追剧、办公甚至阅读。形态之争的背后，其实是用户对更多可能性与便利性的向往。",
      "至于它能否取代传统直板机成为主流，时间会给出答案。但可以确定的是，科技的每一次跨越，都是从满足一个更挑剔的需求开始的。",
    ],
  },
  {
    slug: "city-run-space-stretching",
    categoryId: "life",
    title: "上班族流行起午休运动，办公室版拉伸课走红网络",
    summary: "利用午休十几分钟拉伸肩颈、活动腰背，办公室运动正以更轻量的方式进入职场人的日常。",
    tag: "健康",
    author: "桃桃",
    date: "09-06",
    time: "13:40",
    views: 267000,
    heat: 398,
    readMin: 3,
    image: "https://readdy.ai/api/search-image?query=young%20office%20worker%20stretching%20at%20a%20bright%20modern%20office%20near%20a%20large%20window%2C%20morning%20warm%20light%2C%20healthy%20energetic%20lifestyle%2C%20editorial%20photography&width=960&height=620&seq=hot-news-office-01&orientation=landscape",
    paragraphs: [
      "久坐肩颈酸痛、腰背僵硬的职场人，如今有了新的解法。利用午休的十几分钟，在工位旁做一套舒缓的拉伸操，成了越来越多上班族的固定日程，相关教程视频也在网上收获了大量点赞收藏。",
      "在互联网公司工作的多多分享说，以前总觉得运动要专门空出时间去健身房，实施起来太难。现在把动作拆到午休和傍晚，一套做完反而更精神，下午的注意力也更集中。",
      "健康专家表示，久坐带来的健康隐患往往是日积月累的，规律的小幅活动远比偶尔的剧烈运动更容易坚持。适当的肩颈与核心训练，能有效缓解肌肉劳损和疲劳感。",
      "不少公司也开始注意到这股风潮，主动在茶水间或休息区设置简易的拉伸区域，有的甚至邀请教练定期组织工间操，把员工健康真正落到实处。",
      "运动不必非要大汗淋漓，找到适合自己的节奏，把健康融入日常，才是长久之道。",
    ],
  },
  {
    slug: "e-commerce-live-anchor-turn",
    categoryId: "society",
    title: "头部主播转战幕后，直播带货江湖迎来新一轮洗牌",
    summary: "当曾经风头无两的名字开始退居幕后，直播电商的流量逻辑与行业规则正悄悄改写。",
    tag: "商业",
    author: "大东",
    date: "09-06",
    time: "09:15",
    views: 834000,
    heat: 755,
    top: true,
    readMin: 5,
    image: "https://readdy.ai/api/search-image?query=modern%20live%20streaming%20studio%20with%20bright%20ring%20lights%20and%20product%20shelves%2C%20smartphone%20on%20tripod%2C%20warm%20backstage%20atmosphere%2C%20editorial%20photography&width=960&height=620&seq=hot-news-live-01&orientation=landscape",
    paragraphs: [
      "曾经牢牢占据头部位置的明星主播们，近期陆续传出转战幕后、调整直播频率的消息。曾经火热的直播带货赛道，正进入一场更理性的洗牌期。",
      "多位从业者分析，随着流量红利见顶和用户审美疲劳，单纯靠嗓门与低价吆喝的时代已经过去。消费者的要求越来越高，从价格敏感转向品质与信任，主播个人IP的光环正在被更精细的供应链能力所稀释。",
      "转向幕后的主播们并未离场，而是把重心放到了选品、供应链与团队建设上，试图把单靠个人魅力的生意，变成可持续运营的组织能力。",
      "与此同时，一批懂产品、会聊天的中小主播正在崛起，他们依托细分品类积累真实粉丝，走出了与头部完全不同的路径。江湖的规则，正在被重写。",
      "热闹褪去之后，真正能留下来的，永远是那些把消费者放在心上的长期主义者。",
    ],
  },
  {
    slug: "independent-film-awards",
    categoryId: "film",
    title: "小众文艺片获奖刷屏，独立电影的春天真的来了吗",
    summary: "一部低成本文艺片在本土电影节大放异彩，也让独立电影与商业片的裂痕再次成为焦点。",
    tag: "电影",
    author: "影评小瓜",
    date: "09-05",
    time: "22:00",
    views: 431000,
    heat: 505,
    readMin: 5,
    image: "https://readdy.ai/api/search-image?query=moody%20independent%20film%20festival%20scene%20with%20film%20projector%20beam%20and%20trophy%20on%20stage%2C%20dark%20cinematic%20warm%20gold%20lighting%2C%20artistic%20editorial%20photography&width=960&height=620&seq=hot-news-indie-01&orientation=landscape",
    paragraphs: [
      "颁奖礼上，一部没有大明星、没有大制作的独立文艺片捧走了最佳影片奖杯，消息瞬间刷屏社交网络。许多人兴奋地感叹：独立电影的春天终于要来了吗？",
      "这部影片的导演在获奖感言里提到，整部片子是用极低的预算完成的，很多镜头都在朋友的协助下借场地拍摄。对她而言，获奖最珍贵的是证明了创作本身的力量可以穿透资源的壁垒。",
      "业内人士也指出，近两年独立电影在发行端不断迎来利好消息：影展巡回增多、线上点映渠道拓宽、观众对差异化内容的兴趣上升，都给了创作者更多被看见的机会。",
      "但硬币的另一面是，商业与艺术的平衡依旧艰难。一部片子获奖容易，让更多小众作品稳定地走向观众，还需要更成熟的产业土壤与更长久的耐心。",
      "无论如何，每一部被看见的独立作品，都在为更多后来者点亮一盏灯。春天的信号，往往就藏在那些仍坚持讲故事的人身上。",
    ],
  },
  {
    slug: "pet-economy-growth",
    categoryId: "life",
    title: "宠物经济持续升温，年轻人为何越来越愿意为毛孩子买单",
    summary: "从精致口粮到智能饮水机，宠物消费不断升级，背后是年轻一代更深层的情感需求。",
    tag: "萌宠",
    author: "布丁",
    date: "09-05",
    time: "16:30",
    views: 610000,
    heat: 690,
    readMin: 4,
    image: "https://readdy.ai/api/search-image?query=adorable%20corgi%20dog%20sitting%20next%20to%20modern%20pet%20food%20bowl%20and%20toys%20in%20a%20cozy%20sunlit%20apartment%2C%20warm%20soft%20lighting%2C%20lifestyle%20editorial%20photography&width=960&height=620&seq=hot-news-pet-01&orientation=landscape",
    paragraphs: [
      "养宠人士的钱包，正在为毛孩子越掏越深。从进口口粮、智能猫砂盆，到定制营养品和宠物保险，宠物消费的升级速度，快得让很多品牌都来不及反应。",
      "在都市里独自生活的阿曼是典型的猫奴，她坦言，给自己买东西会犹豫半天，给猫买却从不手软。照顾它的过程让她感到被需要，也填补了不少独处时的孤独感。",
      "数据显示，宠物消费的主力已明显年轻化，他们愿意为科学喂养和宠物福利支付溢价，也更看重产品的成分、口碑与售后服务。围绕宠物的情绪价值，催生了大量细分赛道。",
      "不过也有声音提醒，爱宠不等于盲目消费。理性评估自身的时间和金钱成本，为宠物提供稳定的陪伴与健康的环境，远比堆砌昂贵的物品更重要。",
      "被毛孩子治愈的瞬间，往往无需用价格衡量。真正温暖的，是那份双向奔赴的陪伴。",
    ],
  },
  {
    slug: "digital-collectible-cooling",
    categoryId: "tech",
    title: "数字藏品热度骤降，喧嚣退去后留下了什么",
    summary: "曾经一抢而空的数字藏品如今遇冷，狂热与理性的拉扯，给整个行业留下了深刻的思考题。",
    tag: "科技",
    author: "冷观瓜",
    date: "09-05",
    time: "10:05",
    views: 372000,
    heat: 466,
    readMin: 4,
    image: "https://readdy.ai/api/search-image?query=abstract%20glowing%20digital%20art%20grid%20on%20a%20dark%20screen%20with%20cool%20blue%20and%20warm%20orange%20light%20reflections%2C%20futuristic%20tech%20concept%20photography&width=960&height=620&seq=hot-news-nft-01&orientation=landscape",
    paragraphs: [
      "前两年一上线就被抢空的数字藏品，如今明显冷了下来。二手价格回落、发行数量收缩，曾站在聚光灯下的新赛道，正在经历一场理性的降温。",
      "回看那轮热潮，很多人抱着转手赚钱的心态涌入，投机情绪一度压过收藏本意。当市场情绪退潮，缺乏真实价值支撑的标的，自然率先遇冷。",
      "行业观察者认为，降温对行业未必是坏事。它挤掉了泡沫，让真正思考内容确权、数字权益与创作者价值的团队沉淀下来，把注意力从短期炒作拉回长期建设。",
      "对普通用户而言，这也是一次难得的风险教育：任何新兴概念都可能有迷人的外衣，投资前更需擦亮眼睛，理性评估自己的承受能力。",
      "潮流总是一阵接一阵，但真正留下来的，永远是那些把技术用在对的地方、愿意长期深耕的价值创造者。",
    ],
  },
];

export const hotRankings: { rank: number; item: NewsItem }[] = [
  ...hotNews
    .filter((n) => n.top)
    .map((n, i) => ({ rank: i + 1, item: n })),
  ...hotNews
    .filter((n) => !n.top)
    .sort((a, b) => b.heat - a.heat)
    .slice(0, 10)
    .map((n, i) => ({ rank: i + 1, item: n })),
].sort((a, b) => a.rank - b.rank);

export const faqs: { q: string; a: string }[] = [
  {
    q: "在线吃瓜的实时榜单多久更新一次？",
    a: "我们的热瓜实时榜单会根据网络热度的波动每 5 分钟自动更新一次，综合搜索指数、讨论量与转发趋势，帮你第一时间锁定此刻全网最受关注的焦点动态。",
  },
  {
    q: "榜单上的热度值是怎么计算的？",
    a: "热度值由多维度信号加权得出，包括各大平台的话题搜索量、原创与转发讨论量、讨论增长速度以及权威信源的提及频率，数值越高代表当前关注度越高。",
  },
  {
    q: "吃到的内容来源可靠吗？",
    a: "我们坚持对每一条新鲜事进行信源核对与交叉验证，优先采用权威媒体和官方发布的一手信息。未经核实的传闻会明确标注，绝不把小道消息包装成既定事实。",
  },
  {
    q: "如何按自己关心的领域快速找到内容？",
    a: "首页顶部的分类导航把资讯划分为明星动态、影视综艺、社会热点、科技数码与生活潮流五大板块，你可以一键进入对应频道，或使用站内搜索精准检索关键词。",
  },
  {
    q: "可以举报不实或侵权内容吗？",
    a: "当然可以。若你发现我们的内容存在事实错误或涉及侵权，欢迎通过页脚或联系页面提交反馈，核实后我们会在第一时间处理并更正，守护真实透明的信息环境。",
  },
];